import React from 'react';
import Page from '../../components/Page.js';
import HeroSection from './components/HeroSection.js';
import HeroSubSection from './components/HeroSubSection.js';
import CarouselSection from './components/CarouselSection.js';
import BlogSection from './components/BlogSection.js';
import ReviewsSection from './components/ReviewsSection.js';

const HomeIndex = () => {
  return (
    <Page title="Clickability">
      <HeroSection />
      <HeroSubSection />
      <CarouselSection />
      <BlogSection />
      <ReviewsSection />
    </Page>
  );
};

export default HomeIndex;
